/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface StoragePolicyRule { 
    /**
     * The storage policy rule type. Supported rule types are: DAYS_SINCE_BDATA_REGISTERED, DAYS_SINCE_BDATA_PRIMARY_PARTITION_VALUE,                   BDATA_REGISTRATION_DATE_RANGE                
     */
    ruleType: string;
    /**
     * The storage policy rule value. This parameter is required
     */
    ruleValue?: number;
    /**
     * The start date for the registration date range in YYYY-MM-DD format
     */
    ruleStartBusinessObjectDataRegistrationDate?: Date;
    /**
     * The end date for the registration date range in YYYY-MM-DD format
     */
    ruleEndBusinessObjectDataRegistrationDate?: Date;
}
